import React from 'react'
import styles from './ContentOpenHeader.less'
import { pt } from 'common-data/proptypehelpers'

export class ContentOpenHeader extends React.Component {
  static propTypes = {
    title: pt.string,
    children: pt.any
  }

  render () {
    const { title, children } = this.props

    return (
      <div className={styles.wrapper}>
        {title ? <h1>{title}</h1> : null}
        {children}
      </div>
    )
  }
}

export default ContentOpenHeader
